import Button from '@/components/atoms/Button'
import Icon from '@/components/atoms/Icon'
import Spinner from '@/components/atoms/Spinner'
import { BoxClass } from '@/components/molecules/Admin/Boxs/BoxClass'
import { CardClass } from '@/components/molecules/Admin/Cards/CardClass'
import { checkDate } from '@/hooks/useCheckDate'
import cohortsService from '@/services/cohortsService'
import liveClassService from '@/services/liveClassService'
import { useAppSelector } from '@/store/hooks'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { twMerge } from 'tailwind-merge'
import dayjs from 'dayjs'
import 'dayjs/locale/pt-br'
import utc from 'dayjs/plugin/utc.js'

dayjs.extend(utc)
dayjs.locale('pt-br')

export function Classes() {
	const {
		matriculate: { classSelect },
		auth: { user },
	} = useAppSelector((state) => state)

	const navigate = useNavigate()

	const { data: liveClassData, isLoading } =
		liveClassService.getLiveClassByCohort()

	const findOnboarding = user?.onboarding_all?.find(
		(onboading) =>
			onboading.curso_id ===
			(classSelect?.curso_id ||
				user.curso_interesse_id ||
				(user?.onboarding_all && user?.onboarding_all[0].curso_id))
	)

	const { data: progressCheckData } = cohortsService.getProgressChecks()

	return (
		<div className='flex w-full'>
			<div className='flex flex-col gap-6 w-full'>
				<h2 className='text-[32px] text-zinc-50 font-bold leading-[130%] -tracking-[0.32px]'>
					{liveClassData?.aula_do_dia?.length
						? 'Aula do Dia'
						: 'Próximas Aulas'}
				</h2>

				<div className='grid grid-cols-1 2lg:grid-cols-[1fr_40%] gap-12 md:gap-9 lg:gap-6 items-start'>
					{(() => {
						if (isLoading) {
							return (
								<div className='flex h-full justify-center'>
									<Spinner />
								</div>
							)
						}

						return (
							<div className='grid gap-3 relative'>
								{(() => {
									if (
										findOnboarding?.nivel_onboarding &&
										findOnboarding.nivel_onboarding < 3
									) {
										return (
											<div className='flex w-full items-center justify-center absolute top-1/2 left-1/2 px-6 py-3 z-10 transform -translate-x-1/2 -translate-y-1/2'>
												<Button className='w-full max-w-max h-auto py-1 xs:py-3 md:py-3 rounded-full px-4 pointer-events-none'>
													<Icon
														name='lock'
														width='18'
														height='18'
														className='text-zinc-50'
													/>
													<p className='ml-3'>Faça o Teste de Nivelamento</p>
												</Button>
											</div>
										)
									}

									if (
										findOnboarding?.nivel_onboarding &&
										findOnboarding.nivel_onboarding === 4
									) {
										return (
											<div className='flex w-full items-center justify-center absolute top-1/2 left-1/2 px-6 py-3 z-10 transform -translate-x-1/2 -translate-y-1/2'>
												<div className='flex flex-col justify-center items-center gap-10'>
													<Button className='w-full max-w-max h-[50px] bg-brand-primary/10 hover:bg-brand-primary/10 border-brand-primary/20 border-solid rounded-full px-4'>
														<Icon
															name='lock'
															width='24px'
															height='24px'
															className='text-light-yellow'
														/>
														<p className='ml-3'>
															Em breve sua turma ficará disponível
														</p>
													</Button>
													<div className='flex flex-col items-center gap-6'>
														<p className='text-lg text-white font-semibold leading-[150%] text-center'>
															Veja os materiais disponíveis na
															<br />
															<span className='relative text-lg text-light-yellow font-bold leading-[150%]'>
																<Icon
																	name='book'
																	width='24px'
																	height='24px'
																	className='text-light-yellow flex absolute -left-[30px] top-[2px]'
																/>
																Biblioteca{' '}
															</span>
															por enquanto
														</p>
														<Button
															className='w-full max-w-max text-lg h-[45px] rounded-full px-6'
															onClick={() => navigate('/curso/biblioteca')}
														>
															Acessar Biblioteca
														</Button>
													</div>
												</div>
											</div>
										)
									}

									return <></>
								})()}

								{(() => {
									if (liveClassData?.proximas_aulas?.length) {
										return (
											<div
												className={twMerge(
													classNames('flex flex-col gap-8', {
														'blur-[1.80px] opacity-30 pointer-events-none':
															findOnboarding?.nivel_onboarding &&
															findOnboarding.nivel_onboarding <= 4,
													})
												)}
											>
												{liveClassData?.aula_do_dia?.[0]
													? (() => {
															const _class = liveClassData.aula_do_dia[0]
															const { isHappening, inThePast } = checkDate(
																_class.data_aula.slice(0, 10) +
																	' ' +
																	_class.horario_inicio,
																15,
																75
															)

															return (
																<CardClass
																	key={_class.id}
																	liveClass={_class}
																	classIsHappening={isHappening}
																	classInThePast={inThePast}
																	isActive={true}
																/>
															)
														})()
													: (() => {
															const _class = liveClassData.proximas_aulas[0]
															const { isHappening, inThePast } = checkDate(
																_class.data_aula.slice(0, 10) +
																	' ' +
																	_class.horario_inicio,
																15,
																75
															)

															return (
																<CardClass
																	key={_class.id}
																	liveClass={_class}
																	classIsHappening={isHappening}
																	classInThePast={inThePast}
																	isActive={true}
																/>
															)
														})()}
												{liveClassData?.proximas_aulas?.length && (
													<div className='flex flex-col gap-4'>
														<h2 className='text-[32px] text-white font-bold leading-[130%] -tracking-[0.32px]'>
															Aulas Agendadas
														</h2>
														{(!liveClassData?.aula_do_dia?.[0]
															? liveClassData?.proximas_aulas?.slice(1)
															: liveClassData?.proximas_aulas
														)?.map((_class, key) => {
															const { isHappening, inThePast } = checkDate(
																_class.data_aula.slice(0, 10) +
																	' ' +
																	_class.horario_inicio,
																15,
																75
															)

															return (
																<CardClass
																	key={key}
																	liveClass={_class}
																	classIsHappening={isHappening}
																	classInThePast={inThePast}
																/>
															)
														})}
													</div>
												)}
											</div>
										)
									}

									if (
										!liveClassData?.proximas_aulas.length &&
										!isLoading &&
										user &&
										(findOnboarding?.nivel_onboarding === 0 ||
											(findOnboarding?.nivel_onboarding &&
												findOnboarding?.nivel_onboarding > 4))
									) {
										return (
											<div className='w-full p-6 flex items-center bg-[rgba(49,33,68,0.2)] rounded-xl'>
												<p className='text-[14px] text-white md:text-[18px] font-semibold ml-4'>
													Nenhuma aula agendada no momento.
												</p>
											</div>
										)
									}

									return [1, 2, 3, 4].map((_, key) => {
										return (
											<div
												key={key}
												className={twMerge(
													classNames(
														'w-full bg-zinc-900 p-6 rounded-xl flex flex-col md:flex-row md:items-center justify-between cursor-default',
														{
															'blur-[1.80px] opacity-30 pointer-events-none':
																findOnboarding?.nivel_onboarding &&
																findOnboarding.nivel_onboarding <= 4,
														}
													)
												)}
											>
												<div role='status' className='w-full py-2'>
													<div className='flex items-center justify-between'>
														<div className='w-1/3'>
															<div className='h-3 rounded-full bg-[#6c6574] w-full mb-2.5'></div>
															<div className='w-32 h-3 bg-[#6c6574] rounded-full'></div>
														</div>
														<div className='h-6 bg-[#6c6574] rounded-full w-1/3'></div>
													</div>
													<span className='sr-only'>Loading...</span>
												</div>
											</div>
										)
									})
								})()}
							</div>
						)
					})()}
					<div className='grid grid-cols-1 gap-4 w-full'>
						{progressCheckData &&
							progressCheckData.progressChecks?.length > 0 &&
							(() => {
								const availableProgressChecks =
									progressCheckData.progressChecks.filter(
										(check) => check.isAvailable
									)

								// Verifica se há progress checks disponíveis
								if (availableProgressChecks.length === 0) {
									return null // Não renderiza nada se não houver progress checks disponíveis
								}

								// Ordena os progress checks disponíveis pela data de início, mais próximos primeiro
								const closestCheck = availableProgressChecks.sort((a, b) => {
									return dayjs(a.data_inicio).diff(dayjs(b.data_inicio))
								})[0] // Pega o progress check mais próximo

								const notStart = dayjs()
									.endOf('day')
									.isBefore(dayjs(closestCheck?.data_inicio).endOf('day'))

								if (notStart) return <></>

								return (
									<BoxClass
										className='flex bg-card-progress-check relative overflow-clip'
										to='/curso/progress-check'
									>
										<div className='flex flex-col h-full justify-between gap-[25px] z-10'>
											<div className='flex flex-col gap-2 md:gap-1'>
												<span className='text-base leading-6 text-[#000000]'>
													Prazo final de resposta:{' '}
													<br className='block xs:hidden' />
													<b>
														{dayjs(closestCheck.data_final).format(
															'DD [de] MMMM'
														)}
													</b>
												</span>
												<p className='text-2xl md:text-[28px] leading-8 font-bold text-[#000000]'>
													Progress Check Disponível
												</p>
											</div>
											<Button className='w-full bg-[#000000] hover:bg-[#000000]/90 max-w-max h-auto py-2 xs:py-[10px] md:py-[10px] rounded-full px-3 xs:px-4'>
												<p className='mr-1 md:mr-3 text-sm xs:text-base'>
													Acessar Progress Check
												</p>
												<Icon
													name='arrow-right'
													width='24'
													height='24'
													className='hidden xs:block'
												/>
											</Button>
										</div>
										<Icon
											name='star-progress-check'
											width='187'
											height='187'
											className='absolute bottom-0 right-0'
										/>
									</BoxClass>
								)
							})()}

						{(() => {
							if (isLoading) {
								return (
									<div className='flex flex-col justify-center'>
										<div className='flex min-h-20 justify-center items-center'>
											<Spinner />
										</div>
									</div>
								)
							}

							return (
								<>
									<BoxClass>
										<div className='flex h-full flex-col justify-between gap-7'>
											<div className='flex gap-2 items-center'>
												<Icon
													name='location'
													width='24px'
													height='24px'
													className='text-light-green'
												/>
												<p className='text-light-green font-bold leading-5 text-base'>
													Ciclo Atual e Progresso
												</p>
											</div>
											{(() => {
												if (liveClassData?.nivel && liveClassData.ciclo) {
													return (
														<div className='flex flex-col gap-2'>
															<p className='text-white text-3xl font-bold leading-[130%] first-letter:capitalize'>
																{liveClassData?.nivel} | {liveClassData?.ciclo}
															</p>
															<p className='text-[#61EECE] text-base leading-5 font-medium'>
																{liveClassData?.progresso_por_nivel}% de
																progresso no{' '}
																<span className='inline-block first-letter:capitalize'>
																	{liveClassData?.nivel}
																</span>
															</p>
														</div>
													)
												}

												return (
													<p className='text-white/70 text-base font-bold leading-[130%] max-w-[390px]'>
														Informações serão exibidas quando a turma estiver
														disponível.
													</p>
												)
											})()}
										</div>
									</BoxClass>

									<BoxClass>
										<div className='flex h-full flex-col justify-between gap-7'>
											<div className='flex gap-2 items-center'>
												<Icon
													name='presence'
													width='24px'
													height='24px'
													className='text-light-blue'
												/>
												<p className='text-light-blue font-medium leading-5 text-base'>
													Taxa de Presença nas Aulas
												</p>
											</div>
											{(() => {
												if (liveClassData?.presenca) {
													return (
														<div className='flex flex-col gap-2'>
															<p className='dark:text-white text-5xl capitalize font-bold leading-[130%]'>
																{liveClassData?.presenca}%
															</p>
														</div>
													)
												}

												return (
													<p className='text-white/70 text-base font-bold leading-[130%] max-w-[390px]'>
														Informações serão exibidas quando a turma estiver
														disponível.
													</p>
												)
											})()}
										</div>
									</BoxClass>
								</>
							)
						})()}

						<BoxClass className='relative' to='/curso/biblioteca'>
							<Icon
								name='pencil'
								width='76px'
								height='76px'
								className='absolute -top-8 -right-8'
							/>
							<div className='flex w-full h-full flex-col justify-between gap-7'>
								<div className='flex gap-2 items-center'>
									<Icon
										name='book'
										width='24px'
										height='24px'
										className='text-light-yellow'
									/>
									<p className='text-light-yellow font-bold leading-5 text-base'>
										Biblioteca
									</p>
								</div>
								<div className='flex w-full justify-between items-center gap-2'>
									<p className='text-white text-2xl font-bold leading-[130%]'>
										Acesse a <br />
										Biblioteca de Conteúdos
									</p>
									<div className='flex bg-white/10 rounded-lg p-2'>
										<Icon name='arrow-right' width='24px' height='24px' />
									</div>
								</div>
							</div>
						</BoxClass>
					</div>
				</div>
			</div>
		</div>
	)
}
